<div class="modal-header">
  <h4 class="modal-title">Új üzenet rögzítése</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (submit)="accept()">
    <div>
      <mat-form-field appearence="fill" style="width: 100%">
        <mat-label>Cím</mat-label>
        <input
          required
          matInput
          type="text"
          name="title"
          formControlName="title"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="width: 100%" appearence="fill" required>
        <mat-label>Komment</mat-label>
        <textarea class="text" matInput formControlName="text"></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="decline()">
    {{ btnCancelText }}
  </button>
  <button type="button" class="btn btn-primary" (click)="accept()">
    {{ btnOkText }}
  </button>
</div>
